<template>
  <ul class="articles__menu-list">
    <li 
        v-for="(article, index) in articles"
        :key="index"
      class="articles__menu-item">
        <button 
          @click="openInfoModal(article)" 
          class="articles__menu-item-btn"
          aria-label="Otwórz szczegóły artykułu {{ article.name }}"
        >
          <span 
            class="articles__menu-item-icon"
            :style="`mask: url(data:image/svg+xml;base64,${article.icon}) no-repeat center; mask-size: contain;`"
          ></span>
          {{ article.name }}
        </button>
    </li>
  </ul>
  <div class="articles__menu-header">
    <translated-text-component translation="links_header" />
  </div>
  <ul class="articles__menu-list">
    <li 
       v-for="(link, index) in links"
      :key="index"
    >
      <a 
        :href="link.url"
        target="_blank"
        class="articles__menu-item-btn"> 
        <span 
          class="articles__menu-item-icon"
          :style="`mask: url(data:image/svg+xml;base64,${link.icon}) no-repeat center; mask-size: contain;`"
        ></span>
        {{ link.name }}
      </a>
    </li>
  </ul>
</template>

<script lang="ts">
import { computed, defineComponent, Ref } from 'vue';
import store                              from '@/store';
import { IArticleElement } from '@/interfaces/IArticleElement';
import { IInfoModalData } from '@/interfaces/IInfoModalData';
import { ILinkElement } from '@/interfaces/ILinkElement';

const ArticleList: object = defineComponent({
  props: {
  },
  setup() {

    const langIndex = computed(() => store.getters.getCurrentLang);


    const articles: Ref<IArticleElement[]> = computed(() => store.state.articles.sort((a, b) => {
      if (a.order === null) return 1;
      if (b.order === null) return -1;
      return a.order - b.order;
    }));

    const links: Ref<ILinkElement[]> = computed(
      () => store.state.links.sort((a, b) => a.order - b.order).filter((link) => link.category === 'side_menu'
    ));

    const openInfoModal = (data: IInfoModalData) => {
      store.commit('openInfoModal', data);
    };
 
    return {
      articles,
      links,
      openInfoModal,
    };
  },
});
export default ArticleList;
</script>

<style scoped lang="scss">
.articles {
  &__menu {
    width: 100%;               
    display: flex;
    padding: 10px;

    &-header {
      color: $yellow-static;
      font-weight: 700;
      margin: 12px 0;;
    }

    &-list {
      list-style-type: none;
      color: $main-font-color;
      font-size: rem(14px);
    }

    &-item {
      color: $white-static;
      
      &:hover {
        color: $font-hover;
      }
      &-btn {
        display: inline-flex;
        align-items: center;
        color: $white-static;

        &:hover {
          color: $font-hover;
        }
      }
      &-icon {
        width: rem(20px);
        height: rem(20px);
        display: inline-block;
        margin-right: rem(8px);
        background-color: currentColor;
      }
    }
  }
}

</style>
